module.exports = __WEBPACK_EXTERNAL_MODULE__meltwater_gaf_identity_client__;